export function getClientToken(): string | null {
	if (typeof document === "undefined") return null;
	const match = document.cookie.match(/(?:^|;\s*)token=([^;]*)/);
	return match ? decodeURIComponent(match[1]) : null;
}

export function setClientToken(token: string): void {
	const secure = window.location.protocol === "https:" ? ";Secure" : "";
	document.cookie = `token=${encodeURIComponent(token)};Path=/;SameSite=Strict${secure};Max-Age=${60 * 60 * 24 * 7}`;
}

export function clearClientToken(): void {
	document.cookie = "token=;Path=/;Max-Age=0";
}

let _tokenRefresher: (() => Promise<string | null>) | null = null;

export function setTokenRefresher(refresher: () => Promise<string | null>): void {
	_tokenRefresher = refresher;
}

let _sessionExpiredHandler: (() => void) | null = null;

/** Opt-in: a portal registers what to do once a 401 survives a token refresh (nothing, by default). */
export function setSessionExpiredHandler(handler: (() => void) | null): void {
	_sessionExpiredHandler = handler;
}

export function notifySessionExpired(): void {
	_sessionExpiredHandler?.();
}

export async function refreshClientToken(): Promise<string | null> {
	if (!_tokenRefresher) return null;
	try {
		const token = await _tokenRefresher();
		if (token) {
			setClientToken(token);
		}
		return token;
	} catch {
		return null;
	}
}
